<template>
  <Form v-slot="{ errors }" :validation-schema="validationSchema" as="div">
    <p :class="$style.commentImage"><img :src="url" alt="" width="100%" /></p>
    <p :class="$style.commentTitle">この画像へのコメント</p>
    <ITextArea v-model="comment" name="comment" :rows="4" :max="COMMENT_MAX" />
    <div :class="$style.commentBtn">
      <IButton @click="onClickCancelButton">キャンセル</IButton>
      <IButton type="primary" :disabled="Boolean(errors.comment)" @click="onClickSaveButton">保存</IButton>
    </div>
  </Form>
</template>

<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/zod';
import { Form } from 'vee-validate';
import { ref } from 'vue';
import * as z from 'zod';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextArea from '@/js/components/molecules/ITextArea.vue';

const COMMENT_MAX = 300;
const props = withDefaults(
  defineProps<{
    url: string;
    text?: string;
  }>(),
  {
    text: '',
  },
);
const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'save', comment: string): void;
}>();
const comment = ref(props.text);
const validationSchema = toTypedSchema(
  z.object({
    comment: z.string().max(COMMENT_MAX),
  }),
);
const onClickCancelButton = () => {
  comment.value = props.text;
  emit('cancel');
};
const onClickSaveButton = () => {
  emit('save', comment.value);
};
</script>

<style module lang="scss">
.commentImage {
  aspect-ratio: 1 / 1;
  background-color: #f0f0f0;
  display: flex;
  margin-bottom: 20px;
  text-align: center;

  > img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
}

.commentTitle {
  font-weight: bold;
  margin-bottom: 6px;
}

.commentBtn {
  display: grid;
  gap: 15px;
  grid-template-columns: 1fr 2fr;
  margin-top: 20px;

  @media (--sp) {
    grid-template-columns: 4fr 5fr;
  }
}
</style>
